import React, { ComponentProps, FC, PropsWithChildren } from "react";
import { Touchable } from "@lookiero/aurora";

type TouchableWithoutFeedbackProps = ComponentProps<typeof Touchable>;

const TouchableWithoutFeedback: FC<PropsWithChildren<TouchableWithoutFeedbackProps>> = ({ children, ...props }) => (
  <Touchable pressableOpacity={1} {...props}>
    {children}
  </Touchable>
);

export { TouchableWithoutFeedback };
